import React, { useContext, useEffect, useState } from 'react';

import { ProfileStateContext } from '../../context/ProfileDataContext';
import { ICompDefault } from '../../utils/interfaces/TypesInterfaces';
import SectionWrapper from '../SectionWrapper';

import styles from './Skills.module.scss';
import { getSkillIcon } from './skillIconMap';

interface ISkillsProps extends ICompDefault {
  topSkillsOnly?: boolean;
}

const Skills = ({ id, className, topSkillsOnly }: ISkillsProps) => {
  const { skillsData } = useContext(ProfileStateContext);
  const [displaySkills, setDisplaySkills] = useState(false);

  useEffect(() => {
    if (skillsData && skillsData.visible && skillsData.skills.length > 0) {
      setDisplaySkills(true);
    }
  }, [skillsData]);

  if (skillsData && displaySkills) {
    const skillsToShow = topSkillsOnly ? skillsData.skills.slice(0, 3) : skillsData.skills;
    const headerText = topSkillsOnly ? 'Top Skills' : 'Skills';
    const containerClass = topSkillsOnly ? styles.topSkillsContainer : styles.skillsContainer;
    const wrapperClass = topSkillsOnly ? styles.topSkillsWrapper : styles.wrapper;

    return (
      <SectionWrapper id={id} headerText={headerText} className={`${wrapperClass}${className ? ` ${className}` : ''}`}>
        <div className={containerClass}>
          {skillsToShow.map((skill: any) => (
            <div key={skill.id} className={styles.skillItem}>
              <div className={styles.skillIcon}>
                {React.createElement(getSkillIcon(skill.id), {
                  'aria-label': `${skill.name}`,
                  className: styles.skillIconSvg,
                })}
              </div>
              <div className={styles.skillInfo}>
                <div className={styles.skillName}>{skill.name}</div>
                <div className={styles.skillActivities}>{skill.activities || 0} activities</div>
              </div>
            </div>
          ))}
        </div>
      </SectionWrapper>
    );
  }

  return null;
};

Skills.defaultProps = {
  topSkillsOnly: false,
};

export default Skills;
